import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TranslationService } from '@lib/translation';

@Component({
  templateUrl: './sso-denied.view.html',
  styleUrls: ['./sso-denied.view.css'],
})
export class SsoDeniedView implements OnInit, OnDestroy {
  public translationsLoaded = false;
  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _translationService: TranslationService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this._translationService.translationReady$().pipe(
      takeUntil(this._destroy$)
    ).subscribe(() => {
      this.translationsLoaded = true;
      this._changeDetectorRef.detectChanges();
    });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
